/* GENERATED FILE - do not edit. Run: node scripts/generate-phosphor-icons.mjs */
import type { JSX } from 'solid-js'
import { IconBase, type IconProps, type WeightRenderers } from './IconBase'

const renderers: WeightRenderers = {
  regular: (color: string): JSX.Element => (
    <g>
      <circle
        cx="128"
        cy="128"
        r="96"
        fill="none"
        stroke={color}
        stroke-miterlimit="10"
        stroke-width="16"
      />
      <polyline
        points="128 72 128 128 184 128"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
    </g>
  ),
  bold: (color: string): JSX.Element => (
    <g>
      <circle
        cx="128"
        cy="128"
        r="96"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      />
      <polyline
        points="128 72 128 128 184 128"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      />
    </g>
  ),
  fill: (_color: string): JSX.Element => (
    <g>
      <path d="M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm56,112H128a7.99541,7.99541,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z" />
    </g>
  ),
}

export const Clock = (props: IconProps) => <IconBase {...props} renderers={renderers} />
